import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switchingChart",
  "use": "icon-switchingChart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-switchingChart\"><path d=\"M875.136 295.136a36 36 0 0 1 36 36v544a36 36 0 0 1-36 36h-544a36 36 0 0 1-36-36V802.88a36 36 0 1 1 72 0v36.272h472v-472h-27.872a36 36 0 1 1 0-72zM693.168 111.92a36 36 0 0 1 36 36v73.12a36 36 0 1 1-72 0v-37.12h-472v472h31.904a36 36 0 1 1 0 72H149.168a36 36 0 0 1-36-36v-544a36 36 0 0 1 36-36z m0 183.216a36 36 0 0 1 36 36v360.784a36 36 0 0 1-36 36H331.136a36 36 0 0 1-36-36V331.136a36 36 0 0 1 36-36h362.032z m-36 72H367.136v288.784h290.032V367.136z\" fill=\"#000000\" opacity=\".65\" p-id=\"5312\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/switchingChart.svg
// module id = ej7q
// module chunks = 55